<div class="p-g form-container">
  <form [formGroup]='otpForm'>

    <div class="p-g-12" *ngIf="inputRequired">
      <div class="form-field p-g-12">
        <div class="form-label">
          <label for="username">{{inputLabel}}</label>
        </div>
        <div class="form-control">
          <input formControlName="otpInput" type="text" pInputText />
        </div>
        <div class="form-errors" *ngIf="otpForm.controls.otpInput.errors  && (otpForm.controls.otpInput.dirty || otpForm.controls.otpInput.touched)">
          <div [hidden]="!otpForm.controls.otpInput.errors.required" translate>
            label_please_enter_otp
          </div>
        </div>
      </div>
    </div>
    <div class="form-buttons p-g-12 p-g-nopad">
      <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel" (click)="closeEditForgot($event)"></button>
      <button pButton type="button" label="Submit" icon="fa fa-check" [disabled]="!otpForm.valid" (click)="OTPProcess($event)"></button>
    </div>
  </form>
</div>
